import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const LINKS = [
    ["Dashboard", "/admin"],
    ["Products", "/admin/products"],
    ["Orders", "/admin/orders"],
    ["Contacts", "/admin/contacts"],
    ["Bookings", "/admin/bookings"],
    ["Build Club", "/admin/build-club"],
    ["Users", "/admin/users"],
    ["Blog", "/admin/blog"],
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-screen bg-[hsl(var(--dust-50))]" data-testid="admin-layout">
            <header className="border-b-2 border-[hsl(var(--ink))] bg-[hsl(var(--ink))] px-4 py-4 text-[hsl(var(--dust-50))] sm:px-6">
                <div className="mx-auto flex max-w-7xl items-center justify-between gap-4">
                    <Link to="/" className="flex items-center gap-3">
                        <img src="/assets/logo.png" alt="" className="h-10 w-auto" />
                        <div>
                            <div className="font-display text-2xl uppercase italic leading-none">Urban Off-Road</div>
                            <div className="font-mono-brand text-[10px] uppercase tracking-wider text-[hsl(var(--primary))]">Admin console</div>
                        </div>
                    </Link>
                    <div className="flex items-center gap-4">
                        <span className="hidden font-mono-brand text-xs text-[hsl(var(--dust-100))] md:inline" data-testid="admin-user-email">{user?.email}</span>
                        <Link to="/" className="font-heading text-xs uppercase tracking-wider text-[hsl(var(--dust-100))] hover:text-[hsl(var(--primary))]">
                            View site
                        </Link>
                        <button onClick={logout} className="font-heading text-xs uppercase tracking-wider text-[hsl(var(--danger))] hover:opacity-80" data-testid="admin-logout">Sign out</button>
                    </div>
                </div>
            </header>
            <div className="mx-auto max-w-7xl gap-8 px-4 py-8 sm:px-6 lg:grid lg:grid-cols-[220px_1fr]">
                <nav className="mb-6 lg:mb-0" data-testid="admin-nav">
                    <ul className="flex overflow-x-auto lg:flex-col lg:gap-1">
                        {LINKS.map(([label, to]) => (
                            <li key={to}>
                                <NavLink
                                    to={to}
                                    end={to === "/admin"}
                                    className={({ isActive }) =>
                                        `block whitespace-nowrap border-l-4 px-4 py-2 font-heading text-sm uppercase tracking-wider transition-colors ${
                                            isActive
                                                ? "border-[hsl(var(--primary))] bg-card text-[hsl(var(--ink))]"
                                                : "border-transparent text-[hsl(var(--ink-soft))] hover:text-[hsl(var(--ink))]"
                                        }`
                                    }
                                    data-testid={`admin-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
                                >
                                    {label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                <main><Outlet /></main>
            </div>
        </div>
    );
}
